module.exports = __webpack_public_path__ + "img/Cardioid-animation.ac7ddff8.png";